import { UserContext, UserModuleType } from "@tm/models"

export const getVatFromUserContext = (userContext?: UserContext): number => {
    return userContext?.modules?.find((x) => x.type === UserModuleType.Catalog)?.vat ?? 0
}

export const getCurrencyFromUserContext = (userContext?: UserContext): string => {
    return userContext?.modules?.find((x) => x.type === UserModuleType.Catalog)?.currencyCode ?? "EUR"
}
